import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import starIcon from '../../assets/images/star-icon.png'

const OurServices = () => {
  const { serviceZigzag } = useStaticQuery(
    graphql`
      query {
        serviceZigzag: allContentfulServiceZigzag(
          sort: { fields: createdAt, order: ASC }
        ) {
          edges {
            node {
              sub
              title
              content
              list {
                list
              }
              image {
                fluid(maxWidth: 810) {
                  ...GatsbyContentfulFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    `
  )

  if (!serviceZigzag) {
    return null
  }

  return (
    <React.Fragment>
      {serviceZigzag.edges.map((zigzag, index) => {
        if (index % 2 === 0) {
          return (
            <div key={index} className="about-area pb-100">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-12">
                    <div className="about-img">
                      <Img
                        loading="eager"
                        fadeIn={false}
                        fluid={zigzag.node.image.fluid}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12">
                    <div className="about-content">
                      <div className="content">
                        <span className="sub-title">
                          <img src={starIcon} alt="icon" /> {zigzag.node.sub}
                        </span>
                        <h2>{zigzag.node.title}</h2>
                        <p>{zigzag.node.content}</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: zigzag.node.list.list,
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        } else {
          return (
            <div key={index} className="our-mission-area pb-100">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-lg-6 col-md-12">
                    <div className="our-mission-content">
                      <div className="content">
                        <span className="sub-title">
                          <img src={starIcon} alt="icon" /> {zigzag.node.sub}
                        </span>
                        <h2>{zigzag.node.title}</h2>
                        <p>{zigzag.node.content}</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: zigzag.node.list.list,
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-12">
                    <div className="our-mission-image">
                      <Img
                        loading="eager"
                        fadeIn={false}
                        fluid={zigzag.node.image.fluid}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      })}
    </React.Fragment>
  )
}

export default OurServices
